import {
  AddDoctorForCaseActionTypes,
  ADD_DOCTOR_FOR_CASE_FAIL,
  ADD_DOCTOR_FOR_CASE_LOADING,
  ADD_DOCTOR_FOR_CASE_SUCCESS,
  AddDoctorForCaseState,
  ADD_DOCTOR_FOR_CASE_UPDATE_API_MSG,
  ADD_DOCTOR_FOR_CASE_UPDATE_API_RES,
} from "./ActionTypes";
import { AddDoctorForCaseRes } from "./Model";

const initialStateGetPosts: AddDoctorForCaseState = {
  loading: false,
  addDoctorForCaseRes: {} as AddDoctorForCaseRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const addDoctorForCaseReducer = (
  state = initialStateGetPosts,
  action: AddDoctorForCaseActionTypes
): AddDoctorForCaseState => {
  switch (action.type) {
    case ADD_DOCTOR_FOR_CASE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_DOCTOR_FOR_CASE_SUCCESS:
      return {
        ...state,
        addDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_DOCTOR_FOR_CASE_FAIL:
      return {
        ...state,
        addDoctorForCaseRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_DOCTOR_FOR_CASE_UPDATE_API_MSG:
      return {
        ...state,
        addDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_DOCTOR_FOR_CASE_UPDATE_API_RES:
      return {
        ...state,
        addDoctorForCaseRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
